import { useCallback } from 'react';

import { PropertyStatus } from '@arrived/common';
import { BlockedOfferingsFlag, FEATURE_FLAGS, useFeature } from '@arrived/feature-flags';
import { Offering, OfferingStatus } from '@arrived/models';
import { useCanUserTransactEarlyAccess, useIsOfferingTrending } from '@arrived/queries';

// TODO: Understand the difference between this and useGetPropertyStatus and figure out a better pattern. It very
//  much feels like we're doing the same logic in both.
export function useGetPropertyStylingStatus() {
  const isOfferingTrending = useIsOfferingTrending();
  const blockedOfferingsFlag = useFeature<BlockedOfferingsFlag>(FEATURE_FLAGS.BLOCKED_OFFERINGS);
  const canUserTransactEarlyAccess = useCanUserTransactEarlyAccess();

  return useCallback(
    (offering: Offering): PropertyStatus => {
      const { id, shortName, fundedPercentNoDebt, status, maxSharesPerAccount } = offering;
      const isBlocked = blockedOfferingsFlag.value?.properties.includes(shortName);
      const isTrending = isOfferingTrending(id);

      if (isBlocked) {
        return PropertyStatus.SOLD_OUT;
      }

      if (status === OfferingStatus.PAUSED) {
        return PropertyStatus.PAUSED;
      }

      if (
        status === OfferingStatus.COMING_SOON ||
        (status === OfferingStatus.TRANSACT_EARLY_ACCESS && !canUserTransactEarlyAccess)
      ) {
        return PropertyStatus.COMING_SOON;
      }

      if (isTrending) {
        return PropertyStatus.TRENDING;
      }

      if (fundedPercentNoDebt >= 100 || status === OfferingStatus.FUNDED) {
        return PropertyStatus.SOLD_OUT;
      }

      if (maxSharesPerAccount != null) {
        return PropertyStatus.LIMITED_OFFERING;
      }

      if (fundedPercentNoDebt >= 94) {
        return PropertyStatus.CLOSE;
      }

      return PropertyStatus.NEW;
    },
    [blockedOfferingsFlag, canUserTransactEarlyAccess, isOfferingTrending]
  );
}
